const useraffiliate = {
    getlist: 'useraffiliatesettlement/getlist-by-admin',
    update: 'useraffiliatesettlement/update'
}
export default useraffiliate
